import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CelebrityGrid from './components/celebrities/CelebrityGrid';
import CelebrityProfile from './components/celebrities/CelebrityProfile';
import ComparisonView from './components/comparison/ComparisonView';
import CompanyDetail from './components/companies/CompanyDetail';
import CompaniesList from './components/companies/CompaniesList';
import CAAPartnership from './components/partnership/CAAPartnership';
import Navigation from './components/layout/Navigation';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/celebrities" />} />
            <Route path="/celebrities" element={<CelebrityGrid />} />
            <Route path="/celebrity/:pbId" element={<CelebrityProfile />} />
            <Route path="/companies" element={<CompaniesList />} />
            <Route path="/company/:companyId" element={<CompanyDetail />} />
            <Route path="/caa-partnership" element={<CAAPartnership />} />
            <Route path="/compare" element={<ComparisonView />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;